export default "__VITE_ASSET__DGl_Leq7__"